const Convert = (price: number, conversion: number) => {
	return price * conversion;
}

export default {
	Convert,
	BOLIVAR: 'Bs.',
	DOLAR: '$'
}